import { Component, OnInit, ViewChild, Inject, AfterViewInit } from '@angular/core';
import { SearchCandidateService } from 'src/app/core/services/searchCandService-service';
import { Router, ActivatedRoute } from '@angular/router';
import {} from 'rxjs/operators';
import { FileData } from 'src/app/shared/models/candidate';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { FetchStatus } from 'src/app/shared/models/status.model';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { SnackbarComponent } from 'src/app/shared/components/snackbar/snackbar.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-search-candidates',
  templateUrl: './search-candidates.component.html',
  styleUrls: ['./search-candidates.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  standalone: false,
})
export class SearchCandidatesComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  candidatesData = [];
  savedCandData = [];
  selectedCandidate;
  selectedCandidateId;
  itemSize = 58;
  candidateBasicDetails;
  companyHiringType1 = localStorage.getItem('fresherCompHiringTypeId');
  fetchStatus: FetchStatus = 'fetching';
  displayedColumns = ['requisitionName', 'applicationDate', 'activityName', 'processName', 'applicationStatus'];
  displayedColumns1 =
    this.companyHiringType1 == '1'
      ? ['candidateId', 'fullName', 'primaryEmail', 'dob', 'cellPhone', 'currentCompany', 'duplicateCheck', 'icon']
      : ['candidateId', 'fullName', 'primaryEmail', 'dob', 'cellPhone', 'currentCompany', 'icon'];
  // displayedColumns1 = ['candidateId', 'fullName', 'primaryEmail', 'dob', 'cellPhone', 'currentCompany','icon'];
  dataSource = new MatTableDataSource();
  tableSource = new MatTableDataSource();
  columnDefs = ['CandidateID', 'Name', 'Personal Number', 'Email Address', 'Date of Birth', 'Last Employer'];
  pageNumber: number;
  companyHiringType;
  recruiter = true;
  column_download = ['candidateId', 'fullName', 'primaryEmail', 'dob', 'cellPhone', 'currentCompany'];
  columnObjMapper = {
    requisition_id: 'Req. ID',
    appliedDate: 'App. Date',
    activityName: 'Activity',
    process: 'Process',
    status: 'Status',
    icon: '',
  };
  candAppIds;
  applicationData = [];
  searchedText = '';
  resumeData;
  fileId;
  resData;
  blob: Blob;
  fileData: FileData = <FileData>{};

  // Advance search variables

  //Following components are use to keep the dropdown in postion
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild('stickSchoolDropdown', { read: MatAutocompleteTrigger })
  stickEveLoc: MatAutocompleteTrigger;
  @ViewChild('stickCollegeDropdown', { read: MatAutocompleteTrigger })
  stickColLoc: MatAutocompleteTrigger;
  @ViewChild('stickCurComDropdown', { read: MatAutocompleteTrigger })
  stickCurComLoc: MatAutocompleteTrigger;
  @ViewChild('stickPastComDropdown', { read: MatAutocompleteTrigger })
  stickPastComLoc: MatAutocompleteTrigger;
  @ViewChild('stickPrimarySkill', { read: MatAutocompleteTrigger })
  stickPrimarySkillLoc: MatAutocompleteTrigger;
  @ViewChild('stickSecondarySkill', { read: MatAutocompleteTrigger })
  stickSecondarySkillLoc: MatAutocompleteTrigger;

  //This scrollEvent function updates the index of dropdown with respect to input field
  scrollEvent = (_event: any): void => {
    if (this.stickEveLoc && this.stickEveLoc.panelOpen) {
      this.stickEveLoc.updatePosition();
    }
    if (this.stickColLoc && this.stickColLoc.panelOpen) {
      this.stickColLoc.updatePosition();
    }

    if (this.stickCurComLoc && this.stickCurComLoc.panelOpen) {
      this.stickCurComLoc.updatePosition();
    }

    if (this.stickPastComLoc && this.stickPastComLoc.panelOpen) {
      this.stickPastComLoc.updatePosition();
    }

    if (this.stickPrimarySkillLoc && this.stickPrimarySkillLoc.panelOpen) {
      this.stickPrimarySkillLoc.updatePosition();
    }
    if (this.stickSecondarySkillLoc && this.stickSecondarySkillLoc.panelOpen) {
      this.stickSecondarySkillLoc.updatePosition();
    }
  };
  //Complete data dorm group contains all the form fields required for advance filter options
  candidateSearchForm = new UntypedFormGroup({
    candidateId: new UntypedFormControl(''),
    firstName: new UntypedFormControl(''),
    middleName: new UntypedFormControl(''),
    lastName: new UntypedFormControl(''),
    dob: new UntypedFormControl(),
    email: new UntypedFormControl('', Validators.email),
    mobileNo: new UntypedFormControl('', Validators.pattern('^[0-9 ]*$')),
    pan: new UntypedFormControl(''),
    school: new UntypedFormControl(''),
    college: new UntypedFormControl(''),
    currentCompany: new UntypedFormControl(''),
    pastCompany: new UntypedFormControl(''),
    primarySkill: new UntypedFormControl(),
    secondarySkill: new UntypedFormControl(),
    experience: new UntypedFormControl(''),
    location: new UntypedFormControl(),
  });
  //Dummy form controls to store the typed value of the user
  dmyFrmCtrlLoc = new UntypedFormControl('');
  dmyFrmCtrlScl = new UntypedFormControl('');
  dmyFrmCtrlClg = new UntypedFormControl('');
  dmyFrmCtrlCurCmp = new UntypedFormControl('');
  dmyFrmCtrlPrevCmp = new UntypedFormControl('');
  dmyFrmCtrlPrmSkl = new UntypedFormControl('');
  dmyFrmCtrlSecSkl = new UntypedFormControl('');

  //flag to indicate when to show advance search options
  activeAdvanceSearch: boolean = false;
  showTableData: boolean = true; //Flag to indicate when to show data table
  instituteList: any[] = []; //List of all institutes from API
  companyList: any[] = []; // List of all companies from API
  selectedInstituteList: any[] = []; //List of schools to populate in school dropdown
  selectedCollegeList: any[] = []; //List of colleges to populate in college dropdown
  selectedCurrentCompany: any[] = []; //List of company to populate in current company dropdown
  selectedPastCompany: any[] = []; ////List of company to populate in past company dropdown
  selectedPrimarykills: any = []; //List of skills to populate in primary skill dropdown
  selectedSecondarykills: any = []; //List of skill to populate in secondary dropdown
  selectedLocationList: any[] = []; //List of location to populate in location dropdown
  showAllFields = true;
  todayDate = new Date();
  searchCheck: any;
  res: any[];
  showTable: boolean = false;
  dummy: any;
  showMssg: boolean = false;
  selectedCandidateId1: any;

  isFormEmpty() {
    if (
      this.candidateSearchForm.controls['candidateId'].value == '' &&
      this.candidateSearchForm.controls['firstName'].value == '' &&
      this.candidateSearchForm.controls['middleName'].value == '' &&
      this.candidateSearchForm.controls['lastName'].value == '' &&
      this.candidateSearchForm.controls['dob'].value == '' &&
      this.candidateSearchForm.controls['email'].value == '' &&
      this.candidateSearchForm.controls['mobileNo'].value == '' &&
      this.candidateSearchForm.controls['pan'].value == '' &&
      this.candidateSearchForm.controls['school'].value == '' &&
      this.candidateSearchForm.controls['college'].value == '' &&
      this.candidateSearchForm.controls['currentCompany'].value == '' &&
      this.candidateSearchForm.controls['pastCompany'].value == '' &&
      this.candidateSearchForm.controls['primarySkill'].value == '' &&
      this.candidateSearchForm.controls['secondarySkill'].value == '' &&
      this.candidateSearchForm.controls['experience'].value == '' &&
      this.candidateSearchForm.controls['location'].value == ''
    ) {
      return true;
    } else {
      return false;
    }
  }

  //To fetch record on the basis of applied filter APPLY button
  onSubmit() {
    if (
      !(!this.candidateSearchForm.dirty && this.candidateSearchForm.pristine) &&
      ((this.candidateSearchForm.controls['candidateId'].value != '' &&
        this.candidateSearchForm.controls['candidateId'].value != null) ||
        (this.candidateSearchForm.controls['firstName'].value != '' &&
          this.candidateSearchForm.controls['firstName'].value != null) ||
        (this.candidateSearchForm.controls['middleName'].value != '' &&
          this.candidateSearchForm.controls['middleName'].value != null) ||
        (this.candidateSearchForm.controls['lastName'].value != '' &&
          this.candidateSearchForm.controls['lastName'].value != null) ||
        (this.candidateSearchForm.controls['dob'].value != '' &&
          this.candidateSearchForm.controls['dob'].value != null) ||
        (this.candidateSearchForm.controls['email'].value != '' &&
          this.candidateSearchForm.controls['email'].value != null) ||
        (this.candidateSearchForm.controls['mobileNo'].value != '' &&
          this.candidateSearchForm.controls['mobileNo'].value != null) ||
        (this.candidateSearchForm.controls['pan'].value != '' &&
          this.candidateSearchForm.controls['pan'].value != null)) &&
      this.candidateSearchForm.valid
    ) {
      this.showAllFields = false;
      this.showTableData = true;
      this.fetchStatus = 'fetching';
      if (this.companyHiringType === '') {
        this._searchCandServ.getCHTById().subscribe((data) => {
          const _type = data[0].Value;
          const comapanyHiringTypes = [];
          let f_name = '';
          localStorage.setItem('companyHiringType', data.type);
          this.companyHiringType = data.type;
          comapanyHiringTypes.push(data.type);
          //console.log("!!!IF CHT",this.isFormEmpty());
          if (this.isFormEmpty()) {
            f_name = this.searchedText;
          } else {
            f_name = this.candidateSearchForm.controls['firstName'].value;
          }
          const searchBody = {
            candidateId: this.candidateSearchForm.controls['candidateId'].value,
            firstName: f_name,
            middleName: this.candidateSearchForm.controls['middleName'].value,
            lastName: this.candidateSearchForm.controls['lastName'].value,
            dob: this.datepipe.transform(this.candidateSearchForm.controls['dob'].value, 'dd-MM-yyyy'),
            email: this.candidateSearchForm.controls['email'].value,
            telephone: this.candidateSearchForm.controls['mobileNo'].value,

            school: this.candidateSearchForm.controls['school'].value,
            college:
              this.candidateSearchForm.controls['college'].value == null
                ? ''
                : this.candidateSearchForm.controls['college'].value.instituteName,
            currentCompany:
              this.candidateSearchForm.controls['currentCompany'].value == null
                ? ''
                : this.candidateSearchForm.controls['currentCompany'].value,
            pastCompany:
              this.candidateSearchForm.controls['pastCompany'].value == null
                ? ''
                : this.candidateSearchForm.controls['pastCompany'].value.organizationName,
            primarySkill:
              this.candidateSearchForm.controls['primarySkill'].value == null
                ? ''
                : this.candidateSearchForm.controls['primarySkill'].value.skill_id,
            secondarySkill:
              this.candidateSearchForm.controls['secondarySkill'].value == null
                ? ''
                : this.candidateSearchForm.controls['secondarySkill'].value.skill_id,
            experience: this.candidateSearchForm.controls['experience'].value,
            location:
              this.candidateSearchForm.controls['location'].value == null
                ? ''
                : this.candidateSearchForm.controls['location'].value.city_id,
            companyHiringType: comapanyHiringTypes[0],
          };
          if (searchBody && searchBody.companyHiringType) {
            this.ngxLoader.start();
            this._searchCandServ.advSearchCandidate(searchBody).subscribe(
              (result) => {
                this.candidatesData = result;
                this.dataSource.data = this.candidatesData;
                this.dataSource.paginator = this.paginator;

                if (this.candidatesData && this.candidatesData.length > 0) {
                  this.fetchStatus = 'done';
                } else {
                  this.fetchStatus = 'none';
                }
                this.ngxLoader.stop();
              },
              (_err) => {
                this.fetchStatus = 'error';
                this.ngxLoader.stop();
              },
            );
          }
        });
      } else {
        const comapanyHiringTypes = [];
        let f_name = '';
        comapanyHiringTypes.push(this.companyHiringType);

        if (this.isFormEmpty()) {
          f_name = this.searchedText;
        } else {
          f_name = this.candidateSearchForm.controls['firstName'].value;
        }

        const searchBody = {
          candidateId: this.candidateSearchForm.controls['candidateId'].value,
          firstName: f_name,
          middleName: this.candidateSearchForm.controls['middleName'].value,
          lastName: this.candidateSearchForm.controls['lastName'].value,
          dob: this.datepipe.transform(this.candidateSearchForm.controls['dob'].value, 'dd-MM-yyyy'),
          email: this.candidateSearchForm.controls['email'].value,
          telephone: this.candidateSearchForm.controls['mobileNo'].value,
          school: this.candidateSearchForm.controls['school'].value,
          college:
            this.candidateSearchForm.controls['college'].value == null
              ? ''
              : this.candidateSearchForm.controls['college'].value.instituteName,
          currentCompany:
            this.candidateSearchForm.controls['currentCompany'].value == null
              ? ''
              : this.candidateSearchForm.controls['currentCompany'].value,
          pastCompany:
            this.candidateSearchForm.controls['pastCompany'].value == null
              ? ''
              : this.candidateSearchForm.controls['pastCompany'].value.organizationName,
          primarySkill:
            this.candidateSearchForm.controls['primarySkill'].value == null
              ? ''
              : this.candidateSearchForm.controls['primarySkill'].value.skill_id,
          secondarySkill:
            this.candidateSearchForm.controls['secondarySkill'].value == null
              ? ''
              : this.candidateSearchForm.controls['secondarySkill'].value.skill_id,
          experience: this.candidateSearchForm.controls['experience'].value,
          location:
            this.candidateSearchForm.controls['location'].value == null
              ? ''
              : this.candidateSearchForm.controls['location'].value.city_id,
          companyHiringType: comapanyHiringTypes[0],
        };
        if (searchBody && searchBody.companyHiringType) {
          this.ngxLoader.start();
          this._searchCandServ.advSearchCandidate(searchBody).subscribe(
            (result) => {
              this.candidatesData = result;
              this.dataSource.data = this.candidatesData;
              this.dataSource.paginator = this.paginator;
              if (this.candidatesData && this.candidatesData.length > 0) {
                this.fetchStatus = 'done';
              } else {
                this.fetchStatus = 'none';
              }
              this.ngxLoader.stop();
            },
            (_err) => {
              this.fetchStatus = 'error';
              this.ngxLoader.stop();
            },
          );
        }
      }
    } else {
      if (this.candidateSearchForm.valid) {
        this.openSnackBar(
          { msg: 'Please enter atleast one field: id, name, DOB, E-mail, mobile', isSuccess: false },
          'fail-snack',
        );
      }
    }
  }
  constructor(
    private _searchCandServ: SearchCandidateService,
    private router: Router,
    private datepipe: DatePipe,
    public activatedRoute: ActivatedRoute,
    private snackBar: MatSnackBar,
    @Inject(NgxUiLoaderService) private ngxLoader: NgxUiLoaderService,
    private fileDownloadService: FileDownloadService,
  ) {
    // if (this.router.getCurrentNavigation().extras.state) {
    //   this.searchedText = this.router.getCurrentNavigation().extras.state.data
    // }
    this.fetchStatus = 'fetching';
    this.ngxLoader.start();
    //Subscribing to the value of advance search button in header
    this._searchCandServ.getActiveAdvanceSearch().subscribe((value) => {
      this.activeAdvanceSearch = value;
      this.showAllFields = true;
      this.showTableData = !value;
      this.candidateSearchForm.reset();
      if (!value) {
        this.dataSource.data = this.savedCandData;
        setTimeout(() => (this.dataSource.paginator = this.paginator));
        this.fetchStatus = this.dataSource.data.length > 0 ? 'done' : 'none';
      }
      this.ngxLoader.stop();
    });
    //this.companyHiringType = localStorage.getItem('companyHiringType') || ''
    this.companyHiringType = '';
  }

  ngOnInit() {
    //Listen to scroll event and helps in updating the position of dropdown w.r.t input field
    window.addEventListener('scroll', this.scrollEvent, true);
    //Initializing the advance search to false. Advance search should come up when button from header is clicked
    this._searchCandServ.setActiveAdvanceSearch(false);

    //Service call to get all the institutes
    // this._searchCandServ.getAllInstitute().subscribe(instituteList =>{
    //   this.instituteList = instituteList;
    // })

    // this._searchCandServ.getAllCompany().subscribe(companyList =>{
    //   this.companyList = companyList;
    // })
    this._searchCandServ.getActiveAdvanceSearch().subscribe((value) => {
      if (value) {
        if (this.instituteList.length < 1) {
          this._searchCandServ.getAllInstitute().subscribe((instituteList) => {
            this.instituteList = instituteList;
          });
        }
        if (this.companyList.length < 1) {
          this._searchCandServ.getAllCompany().subscribe((companyList) => {
            this.companyList = companyList;
          });
        }
      }
    });

    this.callSearch();
    // console.log("souvik ", this.candidatesData)
    // if (this.candidatesData.length > 0) {
    //   this.selectedCandidate = this.candidatesData[0];
    //   // this.getCandidateBasicDetails(this.selectedCandidate);
    //   // this.candAppIds= {
    //   //   candidateId: this.selectedCandidate.candidateId,
    //   //   applicationId: this.selectedCandidate.jobApply[0].applicationId
    //   // };
    //   this.getApplicationIDs(this.selectedCandidate)
    //   // this.dataSource = this.selectedCandidate.jobApply;
    // }
  }
  callSearch() {
    this.searchCheck = this._searchCandServ.getSearchKeyword();
    this.searchedText = this.searchCheck;
    this.fetchStatus = 'fetching';
    if (this.companyHiringType === '') {
      this._searchCandServ.getCHTById().subscribe((data) => {
        const type = data[0].Value;
        const comapanyHiringTypes = [];
        localStorage.setItem('companyHiringType', type);
        this.companyHiringType = type;
        comapanyHiringTypes.push(type);
        const searchBody = {
          searchText: this.searchedText,
          companyHiringTypeId: comapanyHiringTypes,
        };
        if (searchBody.searchText && searchBody.companyHiringTypeId) {
          this.ngxLoader.start();
          this._searchCandServ.searchCandidate(searchBody).subscribe(
            (result) => {
              this.candidatesData = result;
              this.savedCandData = result;
              this.dataSource.data = this.candidatesData;
              this.dataSource.paginator = this.paginator;

              if (this.candidatesData.length > 0) {
                this.fetchStatus = 'done';
              } else {
                this.fetchStatus = 'none';
              }
              this.ngxLoader.stop();
            },
            (_err) => {
              this.fetchStatus = 'error';
              this.ngxLoader.stop();
            },
          );
        }
      });
    } else {
      const comapanyHiringTypes = [];
      comapanyHiringTypes.push(this.companyHiringType);
      const searchBody = {
        searchText: this.searchedText,
        companyHiringTypeId: comapanyHiringTypes,
      };
      if (searchBody.searchText && searchBody.companyHiringTypeId) {
        this.ngxLoader.start();
        this._searchCandServ.searchCandidate(searchBody).subscribe(
          (result) => {
            this.candidatesData = result;
            this.savedCandData = result;
            this.dataSource.data = this.candidatesData;
            this.dataSource.paginator = this.paginator;

            if (this.candidatesData.length > 0) {
              this.fetchStatus = 'done';
            } else {
              this.fetchStatus = 'none';
            }
            this.ngxLoader.stop();
          },
          (_err) => {
            this.fetchStatus = 'error';
            this.ngxLoader.stop();
          },
        );
      }
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  onTypeLocation(val) {
    if (val == '') {
      this.candidateSearchForm.controls['location'].setValue(null);
    }
    if (val != undefined && val != null) {
      const cityKeyword = val.trim();
      if (!cityKeyword.length && cityKeyword !== undefined && cityKeyword != null) {
        this.selectedLocationList = [];
      } else {
        this._searchCandServ.getCitiesVenue(val).subscribe(
          (cityElastic) => {
            this.selectedLocationList = [];
            cityElastic.forEach((element) => {
              this.selectedLocationList.push(element);
              this.selectedLocationList.sort((a, b) => a.city_state_country.localeCompare(b.city_state_country));
            });
          },
          (err) => {
            console.log(err.status);
          },
        );
      }
    }
  }
  onTypeInstitute(typed) {
    if (typed == '') {
      this.candidateSearchForm.controls['school'].setValue('');
    }
    this.selectedInstituteList = [];
    if (typed != undefined && typed != null) {
      const cityKeyword = typed;
      if (!cityKeyword.length && cityKeyword !== undefined && cityKeyword != null) {
        this.selectedInstituteList = [];
      } else {
        //response returns the all city list from venue table
        this.instituteList.forEach((value) => {
          if (value.instituteName.toLowerCase().includes(typed.toLowerCase()))
          //if city name matched we push in venueCitiesArray
          {
            this.selectedInstituteList.push(value);
          }
        });
      }
    }
  }

  onTypeCollege(typed) {
    if (typed == '') {
      this.candidateSearchForm.controls['college'].setValue(null);
    }
    this.selectedCollegeList = [];
    if (typed != undefined && typed != null) {
      const cityKeyword = typed;
      //This condition will prevent forEach operation on data when typed keword is ''(empty)
      if (!cityKeyword.length && cityKeyword !== undefined && cityKeyword != null) {
        this.selectedCollegeList = [];
      } else {
        //response returns the all city list from venue table
        this.instituteList.forEach((value) => {
          if (typed.length > 4) {
            if (value.instituteName.toLowerCase().includes(typed.toLowerCase()))
            //if city name matched we push in venueCitiesArray
            {
              this.selectedCollegeList.push(value);
            }
          } else {
            if (value.instituteName.toLowerCase().startsWith(typed.toLowerCase())) {
              this.selectedCollegeList.push(value);
            }
          }
        });
      }
    }
  }
  onTypeCurrentCompany(typed) {
    if (typed == '') {
      this.candidateSearchForm.controls['currentCompany'].setValue(null);
    }
    this.selectedCurrentCompany = [];
    if (typed != undefined && typed != null) {
      const cityKeyword = typed;
      if (!cityKeyword.length && cityKeyword !== undefined && cityKeyword != null) {
        this.selectedCurrentCompany = [];
      } else {
        //response returns the all city list from venue table
        this.companyList.forEach((value) => {
          if (value.organizationName.toLowerCase().includes(typed.toLowerCase()))
          //if city name matched we push in venueCitiesArray
          {
            this.selectedCurrentCompany.push(value);
          }
        });
      }
    }
  }
  onTypePastCompany(typed) {
    if (typed == '') {
      this.candidateSearchForm.controls['pastCompany'].setValue(null);
    }
    this.selectedPastCompany = [];
    if (typed != undefined && typed != null) {
      const cityKeyword = typed;
      if (!cityKeyword.length && cityKeyword !== undefined && cityKeyword != null) {
        this.selectedPastCompany = [];
      } else {
        //response returns the all city list from venue table
        this.companyList.forEach((value) => {
          if (value.organizationName.toLowerCase().includes(typed.toLowerCase()))
          //if city name matched we push in venueCitiesArray
          {
            this.selectedPastCompany.push(value);
          }
        });
      }
    }
  }
  onTypegetPrimarySkill(val) {
    if (val == '') {
      this.candidateSearchForm.controls['primarySkill'].setValue(null);
    }
    const skillKeyword = val.toString().trim();
    if (
      !skillKeyword.length &&
      skillKeyword !== undefined &&
      skillKeyword != null &&
      typeof skillKeyword === 'string'
    ) {
      this.selectedPrimarykills = [];
    }

    if (typeof val === 'string') {
      this._searchCandServ.getSkillDetails(val.toLowerCase()).subscribe(
        (skillElastic) => {
          this.selectedPrimarykills = skillElastic;
          //this.skills.sort((a,b)=> a.skill_name.localeCompare(b.skill_name));
        },
        // (err) => {
        //   console.log('skill error', err.status);
        // }
      );
    }
  }
  onTypegetSecondarySkill(val) {
    if (val == '') {
      this.candidateSearchForm.controls['secondarySkill'].setValue(null);
    }
    const skillKeyword = val.toString().trim();
    if (
      !skillKeyword.length &&
      skillKeyword !== undefined &&
      skillKeyword != null &&
      typeof skillKeyword === 'string'
    ) {
      this.selectedSecondarykills = [];
    }

    if (typeof val === 'string') {
      this._searchCandServ.getSkillDetails(val.toLowerCase()).subscribe(
        (skillElastic) => {
          this.selectedSecondarykills = skillElastic;
          //this.skills.sort((a,b)=> a.skill_name.localeCompare(b.skill_name));
        },
        // (err) => {
        //   console.log('skill error', err.status);
        // }
      );
    }
  }

  setValueInForm(value, formName) {
    this.candidateSearchForm.controls[formName].setValue(value);
    this.candidateSearchForm.controls[formName].markAsDirty();
  }

  // addInstitute(value){
  //   this.candidateSearchForm.controls['school'].setValue(value);
  //   this.candidateSearchForm.controls['school'].markAsDirty();
  // }
  addCollege(value) {
    const selectedVal = this.selectedCollegeList.find((response) => response.instituteName === value);
    this.candidateSearchForm.controls['college'].setValue(selectedVal);
    this.candidateSearchForm.controls['college'].markAsDirty();
  }
  addCurComp(value) {
    const selectedVal = this.selectedCurrentCompany.find((response) => response.organizationName === value);
    this.candidateSearchForm.controls['currentCompany'].setValue(selectedVal.organizationName);
    this.candidateSearchForm.controls['currentCompany'].markAsDirty();
    // this.dmyFrmCtrl.setValue('');
  }
  addPastComp(value) {
    const selectedVal = this.selectedPastCompany.find((response) => response.organizationName === value);
    this.candidateSearchForm.controls['pastCompany'].setValue(selectedVal);
    this.candidateSearchForm.controls['pastCompany'].markAsDirty();
    // this.dmyFrmCtrl.setValue('');
  }
  addPrimarySkill(value) {
    const selectedVal = this.selectedPrimarykills.find((res) => res.skill_name === value);
    this.candidateSearchForm.controls['primarySkill'].setValue(selectedVal);
    this.candidateSearchForm.controls['primarySkill'].markAsDirty();

    // this.dmyFrmCtrl.setValue('');
  }
  addSecondarySkill(value) {
    const selectedVal = this.selectedSecondarykills.find((res) => res.skill_name === value);
    this.candidateSearchForm.controls['secondarySkill'].setValue(selectedVal);
    this.candidateSearchForm.controls['secondarySkill'].markAsDirty();
    // this.dmyFrmCtrl.setValue('');
  }
  addLocation(value) {
    const selectedVal = this.selectedLocationList.find((res) => res.city_state_country === value);
    this.candidateSearchForm.controls['location'].setValue(selectedVal);
    this.candidateSearchForm.controls['location'].markAsDirty();
  }

  outFocusSchool() {
    if (this.candidateSearchForm.controls['school'].value != '') {
      if (this.dmyFrmCtrlScl.value != this.candidateSearchForm.controls['school'].value) {
        this.dmyFrmCtrlScl.setValue('');
        this.candidateSearchForm.controls['school'].setValue('');
      }
    }
    // else{ let flag = false;
    //   this.instituteList.forEach(value =>{
    //     if(this.dmyFrmCtrlScl.value == value.instituteName) flag = true;
    //   })
    //   if(!flag) this.dmyFrmCtrlScl.setValue('');
    // }
  }
  outFocusLocation() {
    if (this.candidateSearchForm.controls['location'].value != null) {
      if (this.dmyFrmCtrlLoc.value != this.candidateSearchForm.controls['location'].value.city_state_country) {
        this.dmyFrmCtrlLoc.setValue('');
        this.candidateSearchForm.controls['location'].setValue(null);
      }
    }
  }
  outFocusCollege() {
    if (this.candidateSearchForm.controls['college'].value != null) {
      if (this.dmyFrmCtrlClg.value != this.candidateSearchForm.controls['college'].value.instituteName) {
        this.dmyFrmCtrlClg.setValue('');
        this.candidateSearchForm.controls['college'].setValue(null);
      }
    }
  }
  outFocusCurrentCompany() {
    if (this.candidateSearchForm.controls['currentCompany'].value != null) {
      if (this.dmyFrmCtrlCurCmp.value != this.candidateSearchForm.controls['currentCompany'].value.organizationName) {
        this.dmyFrmCtrlCurCmp.setValue('');
        this.candidateSearchForm.controls['currentCompany'].setValue(null);
      }
    }
  }
  outFocusPastCompany() {
    if (this.candidateSearchForm.controls['pastCompany'].value != null) {
      if (this.dmyFrmCtrlPrevCmp.value != this.candidateSearchForm.controls['pastCompany'].value.organizationName) {
        this.dmyFrmCtrlPrevCmp.setValue('');
        this.candidateSearchForm.controls['pastCompany'].setValue(null);
      }
    }
  }
  outFocusPrimarySkill() {
    if (this.candidateSearchForm.controls['primarySkill'].value != null) {
      if (this.dmyFrmCtrlPrmSkl.value != this.candidateSearchForm.controls['primarySkill'].value.skill_name) {
        this.dmyFrmCtrlPrmSkl.setValue('');
        this.candidateSearchForm.controls['primarySkill'].setValue(null);
      }
    }
  }
  outFocusSecondarySkill() {
    if (this.candidateSearchForm.controls['secondarySkill'].value != null) {
      if (this.dmyFrmCtrlSecSkl.value != this.candidateSearchForm.controls['secondarySkill'].value.skill_name) {
        this.dmyFrmCtrlSecSkl.setValue('');
        this.candidateSearchForm.controls['secondarySkill'].setValue(null);
      }
    }
  }

  setValueInTooltip(value) {
    if (value.length > 40) {
      return value;
    } else {
      return null;
    }
  }
  allFilter() {
    this.showAllFields = true;
    this.showTableData = false;
  }

  cancel() {
    this.candidateSearchForm.reset();
    this.dmyFrmCtrlLoc.setValue('');
    this.dmyFrmCtrlScl.setValue('');
    this.dmyFrmCtrlClg.setValue('');
    this.dmyFrmCtrlCurCmp.setValue('');
    this.dmyFrmCtrlPrevCmp.setValue('');
    this.dmyFrmCtrlPrmSkl.setValue('');
    this.dmyFrmCtrlSecSkl.setValue('');
  }

  showField(formName) {
    if (
      this.showAllFields &&
      (this.candidateSearchForm.controls[formName].value == '' ||
        this.candidateSearchForm.controls[formName].value == null)
    ) {
      this.candidateSearchForm.controls[formName].markAsPristine();
    }

    if (
      (this.candidateSearchForm.controls[formName].value != '' &&
        this.candidateSearchForm.controls[formName].value != null) ||
      this.showAllFields ||
      (!this.showAllFields && !this.candidateSearchForm.controls[formName].pristine)
    ) {
      return true;
    } else {
      return false;
    }
  }

  openSnackBar(message: object, panelClass: string) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: message,
      panelClass: panelClass,
      duration: 2000,
    });
  }

  displayCandidate(selectedCandidate) {
    // console.log('displayCandidate',selectedCandidate);

    this.selectedCandidate = selectedCandidate;
    // this.getCandidateBasicDetails(this.selectedCandidate);
    // this.candAppIds= {
    //   candidateId: this.selectedCandidate.candidateId,
    //   applicationId: this.selectedCandidate.jobApply[0].applicationId
    // };
    this.getApplicationIDs(this.selectedCandidate);
    // this.dataSource = this.selectedCandidate.jobApply;
  }
  getCandidateBasicDetails(applicationId, candidateId) {
    this._searchCandServ.getCandidateBasicDetails(applicationId, candidateId).subscribe((res) => {
      this.candidateBasicDetails = res;
      console.log('souvik', this.candidateBasicDetails);
    });
  }
  getApplicationIDs(selectedCandidate) {
    this._searchCandServ.getApplicationIDs(selectedCandidate.candidateId).subscribe((applicationData) => {
      this.applicationData = applicationData;
      console.log(this.applicationData);
      this.dataSource.data = this.applicationData;
      this.dataSource.paginator = this.paginator;
      const appId = this.applicationData[this.applicationData.length - 1].applicationId;
      this.getCandidateBasicDetails(appId, selectedCandidate.candidateId);
      this.candAppIds = {
        candidateId: selectedCandidate.candidateId,
        applicationId: appId,
      };
    });
  }
  openAttachment(row) {
    console.log(row);
    this.fileData.objectId = row.candidateId;
    this.fileData.objectType = 'CD';
    this.fileData.attachmentId = 1;
    this._searchCandServ.getFileId(this.fileData).subscribe((data) => {
      this.fileId = data;
      this._searchCandServ.getResume(this.fileId.id).subscribe(async (data) => {
        if (data) {
          console.log(data);
          this.resData = data;
          const normalizedFileType = this.fileDownloadService.normalizeFileType(this.resData.fileType);
          const baseName = row.candidateId + '_' + row.fullName.replaceAll(' ', '');
          const fileName = baseName.endsWith(normalizedFileType) ? baseName : baseName + normalizedFileType;
          try {
            await this.fileDownloadService.downloadFileFromResponse(this.resData, fileName);
          } catch (err) {
            console.error('Resume download failed', err);
            this.openSnackBar({ msg: 'Resume download failed', isSuccess: false }, 'fail-snack');
          }
        }
      });
    });
  }
  selectCandidate(id) {
    this.selectedCandidateId = id.candidateId;
    console.log(this.selectedCandidateId);
    this.router.navigate(['scheduler/search/candidate', this.selectedCandidateId]);
  }
  goToPage() {
    this.paginator.pageIndex = this.pageNumber - 1; // number of the page you want to jump.
    this.paginator.page.next({
      pageIndex: this.pageNumber,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length,
    });
  }

  duplicateChck(id) {
    this.selectedCandidateId1 = id;
    this._searchCandServ.dupCheck(id).subscribe(
      (res) => {
        console.log(res);
        this.dummy = res;
        if (res && res['applicationList'].length) {
          this.showTable = true;
          // console.log(applicationList);
          const data = res['applicationList'].map((item) => ({
            CandidateID: item.candidateId,
            Name: item.name,
            'Personal Number': item.phoneNumber,
            'Email Address': item.email,
            'Date of Birth': this.datepipe.transform(item.dob, 'MMM d, y'),
            'Last Employer': item.lastEmployer,
          }));
          this.tableSource = new MatTableDataSource(data);
        } else {
          this.showMssg = true;
          // this.showTable = false;
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
      },
    );
  }
  onClose() {
    this.showTable = false;
    this.showMssg = false;
  }
}
